import React from 'react';

const HeaderNullRender = () => {
  return <span></span>;
};

export default HeaderNullRender;
